/**
 * Product Card Slider Element
 * Handles Swiper initialization for product card sliders, especially when loaded dynamically.
 */
class ProductCardSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  init() {
    const swiperEl = this.querySelector(".swiper");
    if (!swiperEl || this.swiper) return;

    const options = {
      direction: "horizontal",
      grabCursor: true,
      speed: 500,
      loop: this.dataset.loop === "true",
      slidesPerView: parseInt(this.dataset.slidesPerView || "4"),
      slidesPerGroup: parseInt(this.dataset.slidesPerGroup || "4"),
      spaceBetween: parseInt(this.dataset.spaceBetween || "16"),
      observer: true,
      observeParents: true,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        320: {
          slidesPerView: parseInt(this.dataset.mobileSlidesPerView || "2"),
          slidesPerGroup: parseInt(this.dataset.mobileSlidesPerView || "2"),
          spaceBetween: 12,
        },
        750: {
          slidesPerView: parseInt(this.dataset.slidesPerView || "4"),
          slidesPerGroup: parseInt(this.dataset.slidesPerGroup || "4"),
          spaceBetween: parseInt(this.dataset.spaceBetween || "16"),
        },
      },
    };

    if (window.Swiper) {
      this.swiper = new window.Swiper(swiperEl, options);
    } else {
      console.error("Swiper not found. Please ensure Swiper is loaded.");
    }
  }
}

if (!customElements.get("product-card-slider-component")) {
  customElements.define(
    "product-card-slider-component",
    ProductCardSliderComponent,
  );
}
